export const getFacetDataMain = (state) => state?.mainFacetData || [];
export const getFacetDataModal = (state) => state?.modalFacetData;
export const getFilterMain = (state) => state?.appliedMainFilters;
export const getFilerModal = (state) => state?.appliedModalFilters;
export const getHttp = (state) => state?.http;
export const getWidgetData = (state) => state?.widgetData;
export const getTotalCount = (state) => state?.modalFacetData?.totalCount;
